import React from 'react';
import { capitalize } from '@utils/utils.astro';
import { Link } from 'react-router-dom';

const DashboardListItem = ({ title, icon, mainView, close }) => {
  return (
    <Link
      to={`/dashboard?view=${title}`}
      className={`dashboard_list_item ${mainView === title ? 'selected' : ''}`}
      onClick={close}
    >
      <span className="dashboard_list_item_icon">
        <img src={icon} alt={title} className="dashboard_list_item_icon_src" />
      </span>
      <h3 className="dashboard_list_item_title">{capitalize(title)}</h3>
    </Link>
  );
};

export default DashboardListItem;
